import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

import * as model from "../../models";
import { ShoppingCartTicketGroupDTO } from "../../services/webservice"
import { TicketCreationDTO } from "../../services/webservice"
import { UnsafeAction } from '../../actions/UnsafeAction';

/* tslint:disable */
@Injectable()
export class ShoppingCartActions {
	static CREATE_SHOPPINGCART = "[ShoppingCart] create Shoppingcart";
	createShoppingCart(): Action {
		return {
			type: ShoppingCartActions.CREATE_SHOPPINGCART
		}
	}

	static CREATE_SHOPPINGCART_SUCCESS = "[ShoppingCart] create Shoppingcart success";
	createShoppingCartSuccess(newShoppingCart: model.ShoppingCart): UnsafeAction {
		return {
			type: ShoppingCartActions.CREATE_SHOPPINGCART_SUCCESS,
			payload: newShoppingCart
		}
	}

	static GET_MY_SHOPPINGCART = "[ShoppingCart] get My Shoppingcart";
	getMyShoppingCart(): Action {
		return {
			type: ShoppingCartActions.GET_MY_SHOPPINGCART
		}
	}

	static GET_MY_SHOPPINGCART_SUCCESS = "[ShoppingCart] get My ShoppingCart success";
	getMyShoppingCartSuccess(myShoppingCart: model.ShoppingCart): UnsafeAction {
		return {
			type: ShoppingCartActions.GET_MY_SHOPPINGCART_SUCCESS,
			payload: myShoppingCart
		}
	}

	static ADD_TICKETS = "[ShoppingCart] add Tickets";
	addTickets(url: string, ticketCreationDTOs: TicketCreationDTO[]) {
		return {
			type: ShoppingCartActions.ADD_TICKETS,
			payload: {url: url, ticketCreationDTOs: ticketCreationDTOs}
		}
	}

	static ADD_VISUAL_TICKETS = "[ShoppingCart] add visual Tickets";
	addVisualTickets(url: string, ticketCreationDTOs: TicketCreationDTO[]) {
		return {
			type: ShoppingCartActions.ADD_VISUAL_TICKETS,
			payload: {url: url, ticketCreationDTOs: ticketCreationDTOs}
		}
	}

	static ADD_VISUAL_BULK_TICKETS = "[ShoppingCart] add visual bulk Tickets";
	addVisualBulkTickets(url: string, ticketCreationDTOs: TicketCreationDTO[]) {
		return {
			type: ShoppingCartActions.ADD_VISUAL_BULK_TICKETS,
			payload: {url: url, ticketCreationDTOs: ticketCreationDTOs}
		}
	}

	static ADD_TICKETS_SUCCESS = "[ShoppingCart] add Tickets success";
	addTicketsSuccess(shoppingCart: model.ShoppingCart) {
		return {
			type: ShoppingCartActions.ADD_TICKETS_SUCCESS,
			payload: shoppingCart
		}
	}

	static GET_DISPLAY_SHOPPINGCART = "[ShoppingCart] get DisplayShoppingCart";
	getDisplayShoppingCart(url:string) {
		return {
			type: ShoppingCartActions.GET_DISPLAY_SHOPPINGCART,
			payload: url
		}
	}

	static GET_DISPLAY_SHOPPINGCART_SUCCESS = "[ShoppingCart] get DisplayShoppingCart success";
	getDisplayShoppingCartSuccess(displayShoppingCart: model.DisplayShoppingCart) {
		return {
			type: ShoppingCartActions.GET_DISPLAY_SHOPPINGCART_SUCCESS,
			payload: displayShoppingCart
		}
	}

	static REMOVE_TICKET = "[ShoppingCart] remove Ticket";
	removeTicket(shoppingCartSecureId: string, ticketItemUuid: string) {
		return {
			type: ShoppingCartActions.REMOVE_TICKET,
			payload: {shoppingCartSecureId: shoppingCartSecureId, ticketItemUuid: ticketItemUuid}
		}
	}

	static REMOVE_TICKET_SUCCESS = "[ShoppingCart] remove Ticket success";
	removeTicketSuccess(shoppingCart: model.ShoppingCart) {
		return {
			type: ShoppingCartActions.REMOVE_TICKET_SUCCESS,
			payload: shoppingCart
		}
	}

	static REMOVE_TICKETS = "[ShoppingCart] remove Tickets";
	removeTickets(url: string, ticketItemUuids: string[]) {
		return {
			type: ShoppingCartActions.REMOVE_TICKETS,
			payload: {url: url, ticketItemUuids: ticketItemUuids}
		}
	}

	static REMOVE_TICKETS_SUCCESS = "[ShoppingCart] remove Tickets success";
	removeTicketsSuccess(shoppingCart: model.ShoppingCart) {
		return {
			type: ShoppingCartActions.REMOVE_TICKETS_SUCCESS,
			payload: shoppingCart
		}
	}

	static DELETE_SHOPPINGCART = "[ShoppingCart] delete ShoppingCart";
	deleteShoppingCart(url: string): UnsafeAction {
		return {
			type: ShoppingCartActions.DELETE_SHOPPINGCART,
			payload: url
		}
	}

	static DETACH_SHOPPINGCART = "[ShoppingCart] detach ShoppingCart";
	detachShoppingCart(url: string, description:string, expiration:string): UnsafeAction {
		return {
			type: ShoppingCartActions.DETACH_SHOPPINGCART,
			payload: {url,description,expiration}
		}
	}

	static ATTACH_SHOPPINGCART = "[ShoppingCart] attach ShoppingCart";
	attachShoppingCart(url: string): UnsafeAction {
		return {
			type: ShoppingCartActions.ATTACH_SHOPPINGCART,
			payload: url
		}
	}

	static DELETE_SHOPPINGCART_SUCCESS = "[ShoppingCart] delete ShoppingCart success";
	deleteShoppingCartSuccess(): Action {
		return {
			type: ShoppingCartActions.DELETE_SHOPPINGCART_SUCCESS
		}
	}

	static DETACH_SHOPPINGCART_SUCCESS = "[ShoppingCart] detached ShoppingCart success";
	detachShoppingCartSuccess(): Action {
		return {
			type: ShoppingCartActions.DETACH_SHOPPINGCART_SUCCESS
		}
	}

	static ATTACH_SHOPPINGCART_SUCCESS = "[ShoppingCart] attach ShoppingCart success";
	attachShoppingCartSuccess(): Action {
		return {
			type: ShoppingCartActions.ATTACH_SHOPPINGCART_SUCCESS
		}
	}

	static ORDER_COMMENT_CHANGED = "[ShoppingCart] order comment changed";
	updateOrderComment(value: string): UnsafeAction {
		return {
			type: ShoppingCartActions.ORDER_COMMENT_CHANGED,
			payload: value
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart.actions.ts